/**
 * @flow
 * @format
 */

import _StackedGroup from './StackedGroup';

export default _StackedGroup;



// WEBPACK FOOTER //
// ./src/components/StackedGroup/index.js